'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQCategoryProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function FAQCategory({
  categories,
  activeCategory,
  onCategoryChange,
}: FAQCategoryProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const categoryIcons: Record<string, string> = {
    Semua: 'Squares2X2Icon',
    Perkhidmatan: 'SparklesIcon',
    'Harga & Bayaran': 'CurrencyDollarIcon',
    'Proses & Masa': 'ClockIcon',
    'Kualiti & Jaminan': 'ShieldCheckIcon',
    'Untuk Agent': 'UserGroupIcon',
    'Kawasan & Penghantaran': 'MapPinIcon',
  };

  if (!isHydrated) {
    return (
      <div className="w-full mb-8 overflow-x-auto">
        <div className="flex space-x-3 min-w-max px-4 lg:px-0 lg:justify-center">
          {categories.map((category) => (
            <button
              key={category}
              disabled
              className="flex items-center space-x-2 px-4 py-2 rounded-lg border-2 border-border bg-card text-textSecondary font-body font-medium whitespace-nowrap transition-all duration-300"
            >
              <Icon name={(categoryIcons[category] as any) || 'QuestionMarkCircleIcon'} size={18} />
              <span>{category}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full mb-8 overflow-x-auto">
      <div className="flex space-x-3 min-w-max px-4 lg:px-0 lg:justify-center">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => onCategoryChange(category)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg border-2 font-body font-medium whitespace-nowrap transition-all duration-300 transform hover:scale-105 ${
              activeCategory === category
                ? 'border-primary bg-gradient-to-r from-primary to-secondary text-white shadow-brand'
                : 'border-border bg-card text-textSecondary hover:border-primary hover:text-primary'
            }`}
          >
            <Icon
              name={(categoryIcons[category] as any) || 'QuestionMarkCircleIcon'}
              size={18}
              variant={activeCategory === category ? 'solid' : 'outline'}
            />
            <span>{category}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
